import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/fonts.js';
import '@xdocs/ui/tokens.css';
import { App } from './App.js';
import { registerServiceWorker } from './pwa/registerServiceWorker.js';

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root element not found — check apps/web/index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// E9 PWA — no-op outside a production build unless the page URL carries
// `?dev` (kill-switch, unregisters + clears caches even in prod). Safe to
// call unconditionally (pwa/WIRING.md §1).
void registerServiceWorker();
